/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { TicketEventStatus } from './TicketEventStatus';
import {
    TicketEventStatusFromJSON,
    TicketEventStatusFromJSONTyped,
    TicketEventStatusToJSON,
    TicketEventStatusToJSONTyped,
} from './TicketEventStatus';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TicketEventDetail
 */
export interface TicketEventDetail {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof TicketEventDetail
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof TicketEventDetail
     */
    startsAtUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    startsAtLocal: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    venue: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    description: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TicketEventDetail
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {number}
     * @memberof TicketEventDetail
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    currency: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    capacity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    soldCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    remaining: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    maxPerOrder: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {TicketEventStatus}
     * @memberof TicketEventDetail
     */
    status: TicketEventStatus;
    /**
     * 
     * @type {Date}
     * @memberof TicketEventDetail
     */
    salesEndUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    salesEndLocal: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TicketEventDetail
     */
    purchasable: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    sold: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    held: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    paidOrders: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketEventDetail
     */
    checkedIn: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof TicketEventDetail
     */
    revenue: number;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TicketEventDetail
     */
    quantityDealPayFor?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TicketEventDetail
     */
    quantityDealReceive?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    promoCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    promoDiscountKind?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof TicketEventDetail
     */
    promoDiscountValue?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof TicketEventDetail
     */
    locationName?: string | null;
}



/**
 * Check if a given object implements the TicketEventDetail interface.
 */
export function instanceOfTicketEventDetail(value: object): value is TicketEventDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startsAtUtc' in value) || value['startsAtUtc'] === undefined) return false;
    if (!('startsAtLocal' in value) || value['startsAtLocal'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('soldCount' in value) || value['soldCount'] === undefined) return false;
    if (!('remaining' in value) || value['remaining'] === undefined) return false;
    if (!('maxPerOrder' in value) || value['maxPerOrder'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('salesEndUtc' in value) || value['salesEndUtc'] === undefined) return false;
    if (!('salesEndLocal' in value) || value['salesEndLocal'] === undefined) return false;
    if (!('purchasable' in value) || value['purchasable'] === undefined) return false;
    if (!('sold' in value) || value['sold'] === undefined) return false;
    if (!('held' in value) || value['held'] === undefined) return false;
    if (!('paidOrders' in value) || value['paidOrders'] === undefined) return false;
    if (!('checkedIn' in value) || value['checkedIn'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    return true;
}

export function TicketEventDetailFromJSON(json: any): TicketEventDetail {
    return TicketEventDetailFromJSONTyped(json, false);
}

export function TicketEventDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketEventDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'slug': json['slug'],
        'name': json['name'],
        'startsAtUtc': (json['startsAtUtc'] == null ? null : new Date(json['startsAtUtc'])),
        'startsAtLocal': json['startsAtLocal'],
        'venue': json['venue'],
        'description': json['description'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'price': json['price'],
        'currency': json['currency'],
        'capacity': ApiUserTasksGetPageParameterFromJSON(json['capacity']),
        'soldCount': ApiUserTasksGetPageParameterFromJSON(json['soldCount']),
        'remaining': ApiUserTasksGetPageParameterFromJSON(json['remaining']),
        'maxPerOrder': ApiUserTasksGetPageParameterFromJSON(json['maxPerOrder']),
        'status': TicketEventStatusFromJSON(json['status']),
        'salesEndUtc': (json['salesEndUtc'] == null ? null : new Date(json['salesEndUtc'])),
        'salesEndLocal': json['salesEndLocal'],
        'purchasable': json['purchasable'],
        'sold': ApiUserTasksGetPageParameterFromJSON(json['sold']),
        'held': ApiUserTasksGetPageParameterFromJSON(json['held']),
        'paidOrders': ApiUserTasksGetPageParameterFromJSON(json['paidOrders']),
        'checkedIn': ApiUserTasksGetPageParameterFromJSON(json['checkedIn']),
        'revenue': json['revenue'],
        'quantityDealPayFor': json['quantityDealPayFor'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealPayFor']),
        'quantityDealReceive': json['quantityDealReceive'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealReceive']),
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'promoDiscountKind': json['promoDiscountKind'] == null ? undefined : json['promoDiscountKind'],
        'promoDiscountValue': json['promoDiscountValue'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['promoDiscountValue']),
        'locationName': json['locationName'] == null ? undefined : json['locationName'],
    };
}

export function TicketEventDetailToJSON(json: any): TicketEventDetail {
    return TicketEventDetailToJSONTyped(json, false);
}

export function TicketEventDetailToJSONTyped(value?: TicketEventDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'slug': value['slug'],
        'name': value['name'],
        'startsAtUtc': value['startsAtUtc'] == null ? value['startsAtUtc'] : value['startsAtUtc'].toISOString(),
        'startsAtLocal': value['startsAtLocal'],
        'venue': value['venue'],
        'description': value['description'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'price': value['price'],
        'currency': value['currency'],
        'capacity': ApiUserTasksGetPageParameterToJSON(value['capacity']),
        'soldCount': ApiUserTasksGetPageParameterToJSON(value['soldCount']),
        'remaining': ApiUserTasksGetPageParameterToJSON(value['remaining']),
        'maxPerOrder': ApiUserTasksGetPageParameterToJSON(value['maxPerOrder']),
        'status': TicketEventStatusToJSON(value['status']),
        'salesEndUtc': value['salesEndUtc'] == null ? value['salesEndUtc'] : value['salesEndUtc'].toISOString(),
        'salesEndLocal': value['salesEndLocal'],
        'purchasable': value['purchasable'],
        'sold': ApiUserTasksGetPageParameterToJSON(value['sold']),
        'held': ApiUserTasksGetPageParameterToJSON(value['held']),
        'paidOrders': ApiUserTasksGetPageParameterToJSON(value['paidOrders']),
        'checkedIn': ApiUserTasksGetPageParameterToJSON(value['checkedIn']),
        'revenue': value['revenue'],
        'quantityDealPayFor': ActorActivityRecordActorUserIdToJSON(value['quantityDealPayFor']),
        'quantityDealReceive': ActorActivityRecordActorUserIdToJSON(value['quantityDealReceive']),
        'promoCode': value['promoCode'],
        'promoDiscountKind': value['promoDiscountKind'],
        'promoDiscountValue': BalanceUnitStatementEntryDebitToJSON(value['promoDiscountValue']),
        'locationName': value['locationName'],
    };
}

